import axios from 'axios'
import apiURL from './api'
import router from '../router'

// axios默认配置
axios.defaults.timeout = 120000;   // 超时时间
axios.defaults.baseURL = apiURL;  // 默认地址

// // 路由响应拦截
// // http response 拦截器
axios.interceptors.response.use(
  response => {
      if(response.data.status_code == 402){
        // console.log(response)
        // console.log(1111)
        // localStorage.clear()
        localStorage.removeItem("user_id");
        router.push({
          path:'/'
        })
        return 
    }else{
        return response;
    }
  },
  error => {
    return Promise.reject(error.response)   // 返回接口返回的错误信息
  });
export default axios;